import React, { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";
import "../styles/PDFSidebar.css";

// Shows the selected resources for PDF printing
const PDFSidebar = () => {
  const { selectedResources, removeSelectedResource } = useContext(AuthContext);

  if (selectedResources.length === 0) return null; // Hide sidebar if no resources are selected

  return (
    <div className="sidebar">
      <h3>Selected Resources</h3>
      <ul>
        {selectedResources.map((resource) => (
          <li key={resource._id}>
            {resource.Name}
            <button onClick={() => removeSelectedResource(resource._id)}>❌</button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PDFSidebar;
